<template>
  <div class="home">
    <h1>
      Home Page
    </h1>

    <p>
      newpage
    </p>
  </div>
</template>

<script>
export default {
  name: "Newpage"
};
</script>
